import React from 'react';
import { motion } from 'framer-motion';
type ButtonVariant = 'primary' | 'secondary';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: ButtonVariant;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
}
const variantClasses: Record<ButtonVariant, string> = {
  primary: 'text-white bg-orange hover:bg-orange-deep shadow-[0_10px_24px_-10px_rgba(242,106,27,0.8)]',
  secondary: 'text-white bg-charcoal hover:bg-graphite border border-orange/60 shadow-[0_10px_24px_-12px_rgba(23,23,26,0.6)]'
};
const baseClasses = 'inline-flex items-center justify-center gap-2 px-8 py-4 text-lg font-bold uppercase tracking-wide rounded-full transition-colors duration-200 ease-out text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-orange';
export function Button({
  children,
  className = '',
  variant = 'primary',
  href,
  target,
  rel,
  onLinkClick,
  ...props
}: ButtonProps) {
  const classes = `${baseClasses} ${variantClasses[variant]} ${className}`;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={classes} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.14,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-63" data-mp="i2mn87y6k5p1">
        {children}
      </motion.a>;
  }
  return <motion.button className={classes} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} {...props} data-id="element-64" data-mp="3ufuam7spzcux">
      {children}
    </motion.button>;
}